

//  React base styles
import tableDesign from "assets/theme/components/table/tableDesign";

//  React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const tableCell = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(12)} ${pxToRem(16)}`,
      borderBottom: tableDesign.rowDivider,
    },
  },
};

export default tableCell;
